<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab>
        Tabela
      </v-tab>
      <v-tab>
        Wykres
      </v-tab>
      <v-tab-item>
        <v-data-table :loading="!isInit" :headers="tableHeader" :items="tableData">
          <template v-slot:item.dateTime="{item}">
            {{moment(item.dateTime).format("YYYY-MM-DD")}}
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-col cols="12" lg="3">
          <v-select v-model="itemsCount" :items="selectItems" label="Ilość wyświetlanych wdrożeń"></v-select>
        </v-col>
        <line-chart v-if="filteredChartData" :chartData="filteredChartData"
                    :height="800"
                    :options="{maintainAspectRatio:false, scales:{yAxes:[{ticks:{beginAtZero:true}}]}}"></line-chart>
      </v-tab-item>
    </v-tabs>
    <v-row>
    </v-row>
  </div>
</template>

<script>
import {lineChart} from "@/components/charts";
import {getNextColorForChart, resetColorForChart} from "@/helpers";

export default {
  components: {
    lineChart
  },
  computed: {
    filteredChartData() {
      if (this.chartData) {
        var datasets = []
        if (this.itemsCount > 0) {
          datasets = this.chartData.datasets.slice(0, this.itemsCount)
        } else {
          datasets = this.chartData.datasets;
        }
        return {
          labels: this.chartData.labels,
          datasets: datasets
        }
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      isInit: false,
      tab: null,
      selectItems: [
        {text: '10', value: 10},
        {text: '20', value: 20},
        {text: '50', value: 50},
        {text: 'Wszystkie', value: 0}
      ],
      itemsCount: 10,
      chartData: null,
      tableData: [],
      tableHeader: [
        {
          text: 'Nazwa wdrożenia',
          value: 'companyName'
        },
        {
          text: 'Data',
          value: 'dateTime'
        },
        {
          text: 'Ilość potwierdzonych rezerwacji',
          value: 'count'
        }
      ]

    }
  },
  mounted() {
    resetColorForChart('lastWeekConfirmReservation')
    var vm = this;
    vm.$http.get("Report/LastWeekConfirmedReservation").then(response => {
      vm.chartData = {
        labels: response.data.labels,
        datasets: response.data.datasets
      }
      vm.tableData = response.data.listData;
      vm.isInit = true;
      vm.chartData.datasets.forEach(el=>el.borderColor = getNextColorForChart('lastWeekConfirmReservation'))
    })
  }
};
</script>
